import { useMemo } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";
import { Box, Stack, Typography } from "@mui/material";
import { AccessTime } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const HomeAreaChartComponent = ({
  beginAtZero = false,
  volumeData,
  unitOfMeasure,
}) => {
  const { t } = useTranslation();
  const transformedData = useMemo(() => {
    if (!volumeData || volumeData.length === 0)
      return { labels: [], datasets: [] };

    const labels = volumeData.map((item) => dayjs(item.datetime).format("MMM"));

    const minValues = volumeData.map((item) => parseFloat(item.min));
    const meanValues = volumeData.map((item) => parseFloat(item.mean));
    const maxValues = volumeData.map((item) => parseFloat(item.max));

    return {
      labels,
      datasets: [
        {
          label: "Forecast min",
          data: minValues,
          fill: true,
          backgroundColor: "white",
          borderColor: "rgba(54, 162, 235, 1)",
        },
        {
          label: "Forecast max",
          data: maxValues,
          fill: true,
          backgroundColor: "rgba(75, 192, 192, 0.2)",
          borderColor: "rgba(75, 192, 192, 1)",
        },
        {
          label: "Forecast mean",
          data: meanValues,
          fill: true,
          backgroundColor: "rgba(153, 102, 255, 0.2)",
          borderColor: "rgba(153, 102, 255, 1)",
        },
      ],
    };
  }, [volumeData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: beginAtZero,
        title: {
          display: true,
          text: unitOfMeasure,
          font: {
            size: 12,
          },
        },
      },
    },
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "400px",
  };

  const hasNoData =
    !transformedData.datasets.length || !transformedData.labels.length;

  return (
    <div style={containerStyle}>
      {!transformedData || hasNoData ? (
        <Box
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={2}
        >
          <AccessTime />
          <Stack
            direction="column"
            sx={{
              alignItems: "center",
              textAlign: "center",
              "& > *": { marginBottom: "0.2rem" }, // Riduce lo spazio tra gli elementi
            }}
          >
            {t("real-time-page.no_models_data_message")
              .split(".")
              .filter((sentence) => sentence.trim() !== "") // Filtra le stringhe vuote
              .map((sentence, index, array) => (
                <Typography
                  key={index}
                  sx={{ lineHeight: 1.2 }} // Riduce l'altezza della linea
                >
                  {sentence}
                  {index < array.length - 1 ? "." : ""}
                </Typography>
              ))}
          </Stack>
        </Box>
      ) : (
        <Line data={transformedData} options={options} />
      )}
    </div>
  );
};

export default HomeAreaChartComponent;
